'use client';

import {
  FlowContext,
  type FlowExecutionContext,
} from '../contexts/flowContext';

export const FlowProvider = ({
  children,
  context,
}: {
  children: React.ReactNode;
  context: FlowExecutionContext;
}) => <FlowContext.Provider value={context}>{children}</FlowContext.Provider>;
